import { render, staticRenderFns } from "./orderServicerGrab.vue?vue&type=template&id=61b472a6&"
import script from "./orderServicerGrab.vue?vue&type=script&lang=ts&"
export * from "./orderServicerGrab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports